// extracted by css-extract-rspack-plugin
export default {"cls1":"Navbar-cls1_5tS","cls2":"Navbar-cls2_zik Navbar-cls1_5tS"};